// extracted by mini-css-extract-plugin
module.exports = {"solutions_main":"solutionsMain_solutions_main__qLIPh","solutions_mobile":"solutionsMain_solutions_mobile__Osmqr"};